import './ResetPasswordPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { postResetPassword, setCredentials } from 'containers/Auth/store/actions';

import A from 'components/A';
import Button from 'components/Button';
import Modal from 'components/Modal';
import ResetPasswordForm from './ResetPasswordForm';
import PageContent from 'components/PageContent';

class ResetPasswordPage extends React.Component {
    constructor() {
        super();

        this.state = {
            isInvitation: window.location.pathname.indexOf('/invitation/') !== -1,
            showSuccessModal: false
        };
    }

    componentDidMount() {
        document.body.classList.add('auth-page');
        document.body.classList.add('reset-password-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
        document.body.classList.remove('reset-password-page');
    }

    handleChange(name, value) {
        let newCredentialsObj = update(this.props.auth.credentials, {});
        newCredentialsObj[name] = value;

        this.props.setCredentials(newCredentialsObj);
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            this.props.postResetPassword(this.props.params.token)
                .then((res) => {
                    this.setState({showSuccessModal: true});
                })
        }
    }

    render() {
        return (
            <PageContent className="login-content">
                <div className="login-form--wrapper auth-form--wrapper">

                    <ResetPasswordForm
                        credentials={this.props.auth.credentials}
                        error={this.props.auth.resetPasswordError}
                        handleChange={this.handleChange.bind(this)}
                        isInvitation={this.state.isInvitation}
                        isSubmitting={this.props.auth.isResettingPassword}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        onValid={this.handleSubmit.bind(this, true)}
                    />

                    <div className="auth-page__links">
                        <A to="/login">Back to Login</A>
                    </div>
                </div>

                <Modal show={this.state.showSuccessModal === true}
                       title="Success!">
                    {this.state.isInvitation === true ? (
                        <p>
                            You have successfully set your password. Please login.
                        </p>
                    ) : (
                        <p>
                            Your password has been successfully changed. Please login.
                        </p>
                    )}

                    <div className="c-modal__button-wrapper">
                        <Button onClick={() => {
                            this.setState({showSuccessModal: false});
                            this.props.changeLocation('/login');
                        }}>
                            {this.state.isInvitation === true ? 'Login Now' : 'Back to Login'}
                        </Button>
                    </div>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        postResetPassword: (token) => dispatch(postResetPassword(token)),
        setCredentials: (credentialsObj) => dispatch(setCredentials(credentialsObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/ResetPasswordPage/index.js